import { AppBar, Grid, Toolbar, Typography, makeStyles } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import LoadingIndicator from '../../components/general/loadingIndicator/LoadingIndicator';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    grow: {
        flexGrow: 1,
    },
    toolbar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: theme.spacing(0, 1),
        // necessary for content to be below app bar
        ...theme.mixins.toolbar,
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
        marginLeft: theme.spacing(0),
    },
}));

const MediaServerDenied = () => {
    const classes = useStyles();
    const [loading, setLoading] = useState(true);

    useEffect(() => {

        setLoading(false)

    }, []);


    return (
        <>
            <AppBar
                position="fixed"
                className={classes.appBar}
            >
                <Toolbar>
                    <Typography variant="h6" noWrap>
                        Mobilys
                    </Typography>
                    <div className={classes.grow} />
                </Toolbar>
            </AppBar>
            <main className={classes.content}>
                <div className={classes.toolbar} />
                <LoadingIndicator open={loading} />
                {/* <MySnackbar params={snack} /> */}
                <Grid container alignItems="center" justifyContent="center" spacing={2}>
                    <Grid item>
                        <Typography variant="h2" component="h2" gutterBottom>
                            Accès refusé
                        </Typography>
                    </Grid>
                </Grid>
            </main>
        </>
    )
}

export default MediaServerDenied